/**
 * Identifies alternative moves by comparing variations.
 * An alternative is when two variations have the same move history
 * but diverge with different player moves (playersMove === true).
 * 
 * @param {Array} variations - Array of variation objects with moveList arrays
 * @returns {Set} Set of move IDs that are alternatives
 */
export const getAlternativeMoveIds = (variations) => {
  const alternativeMoveIds = new Set();
  
  // Compare each variation with all others
  for (let i = 0; i < variations.length; i++) {
    for (let j = i + 1; j < variations.length; j++) {
      const var1 = variations[i];
      const var2 = variations[j];
      
      if (!var1.moveList || !var2.moveList) continue;
      
      // Find the point where variations diverge
      let divergenceIndex = -1;
      const minLength = Math.min(var1.moveList.length, var2.moveList.length);
      
      for (let k = 0; k < minLength; k++) {
        const move1 = var1.moveList[k];
        const move2 = var2.moveList[k];
        
        // Compare moves by their notation and prevFen to see if they're the same
        if (move1.notation !== move2.notation || move1.prevFen !== move2.prevFen) {
          divergenceIndex = k;
          break;
        }
      }
      
      // If variations diverge at a player move, mark both as alternatives
      if (divergenceIndex >= 0) {
        const move1 = var1.moveList[divergenceIndex];
        const move2 = var2.moveList[divergenceIndex];
        
        // Check if both are player moves (alternatives only exist for player moves)
        if (move1 && move2 && move1.playersMove && move2.playersMove) {
          // Verify that all previous moves are the same
          let previousMovesMatch = true;
          for (let k = 0; k < divergenceIndex; k++) {
            if (var1.moveList[k].notation !== var2.moveList[k].notation ||
                var1.moveList[k].prevFen !== var2.moveList[k].prevFen) {
              previousMovesMatch = false;
              break;
            }
          }
          
          if (previousMovesMatch) {
            alternativeMoveIds.add(move1.id);
            alternativeMoveIds.add(move2.id);
          }
        }
      }
    }
  }
  
  return alternativeMoveIds;
};

